export enum ReportRouter {
    NewReports = 'reports',
    StandardReports = 'standard-reports',
}
